import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import contract from '@/contract/contract'
import privacyPolicy from '@/contract/privacyPolicy'
import registerAgreement from '@/contract/registerAgreement'
import loanAgreement from '@/contract/loanAgreement'

Vue.use(Router)

export default new Router({
	routes: [{
		path: '/',
		name: 'index',
		component: index
	}, {
		path: '/index',
		name: 'index',
		component: index
	}, {
		path: '/contract/test',
		name: 'contract',
		component: contract
	}, {
		path: '/contract/privacyPolicy',
		name: 'privacyPolicy',
		component: privacyPolicy
	}, {
		path: '/contract/registerAgreement',
		name: 'registerAgreement',
		component: registerAgreement
	}, {
		path: '/contract/loanAgreement',
		name: 'loanAgreement',
		component: loanAgreement
	}]
})


// WEBPACK FOOTER //
// ./src/router/index.js